import { addDays, max } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const RESCHEDULE_WINDOW_DAYS = 14;

function createStableDate(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month - 1, day, 12, 0, 0, 0));
}

function extractDateParts(date: Date | string, timezone: string): [number, number, number] {
  const dateStr = formatInTimeZone(date, timezone, 'yyyy-MM-dd');
  return dateStr.split('-').map(Number) as [number, number, number];
}

export function getRescheduleWindowDates(
  appointmentDate: Date | string,
  timezone: string,
): {
  fromDate: Date;
  toDate: Date;
} {
  const now = new Date();
  const today = createStableDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
  
  const [year, month, day] = extractDateParts(appointmentDate, timezone);
  const appointmentDateOnly = createStableDate(year, month, day);
  
  const fromDateBase = max([today, appointmentDateOnly]);
  const fromDate = addDays(fromDateBase, 1);
  const toDate = addDays(fromDate, RESCHEDULE_WINDOW_DAYS);
  
  return { fromDate, toDate };
}

